import React, { useEffect } from "react";
import { useGetClientVoteQuery } from "../../../../redux/service/modules/sales";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const ClientVotesSpread = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["analyst"]);
    }, []);
    return (
        <PaginatedDataTable
            queryHook={useGetClientVoteQuery}
            initialDateRange={dateRange}
            firstColumnWidth="100px"
            isColumnSticky={true}
            stickyColumnsCount={2}
            appliedFilters={appliedFilters}
        />
    );
};

export default ClientVotesSpread;
